import { render, staticRenderFns } from "./integralCategory.vue?vue&type=template&id=3bc56bfe&scoped=true&"
import script from "./integralCategory.vue?vue&type=script&lang=js&"
export * from "./integralCategory.vue?vue&type=script&lang=js&"
import style0 from "./integralCategory.vue?vue&type=style&index=0&id=3bc56bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc56bfe",
  null
  
)

export default component.exports